import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import {
  KibCloseFullscreenIcon,
  KibOpenFullscreenIcon,
} from '@chewy/kib-icons-react'
import { KibGridItem } from '@chewy/kib-layout-react'

import CommunicationFilter from './CommunicationFilter'

import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './CommunicationHeaderActionButtons.module.scss'

const CommunicationHeaderActionButtons = ({
  onClose,
  onExpand,
  isExpanded,
}: {
  isExpanded?: boolean
  onClose?: () => void
  onExpand?: () => void
}) => {
  const { t } = useTranslation('Clients')
  return (
    <KibGridItem className={styles.noMargins}>
      <CommunicationFilter />
      <KibButtonNew
        iconOnly
        className={styles.expandButton}
        emphasis="tertiary"
        icon={
          isExpanded ? <KibCloseFullscreenIcon /> : <KibOpenFullscreenIcon />
        }
        size="medium"
        theme="utility"
        onClick={isExpanded ? onClose : onExpand}
      >
        {isExpanded
          ? t('Clients:COMMUNICATION_WIDGET.CLOSE_FULLSCREEN')
          : t('Clients:COMMUNICATION_WIDGET.EXPAND_FULLSCREEN')}
      </KibButtonNew>
    </KibGridItem>
  )
}

export default CommunicationHeaderActionButtons
